import React from 'react';
import PropTypes from 'prop-types';

RadioButton.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  selectedOption: PropTypes.object
};

export default function RadioButton({ index, label, value, selectedOption }) {
  const inputValue = JSON.parse(value);

  return (
    <li key={index} className="radio" style={{ marginBottom: '8px' }}>
      <input
        type="radio"
        name="wb-fieldflow wb-auto-1wb-auto-12"
        id={`legislation-${index}`}
        checked={
          selectedOption !== null && selectedOption !== undefined
            ? inputValue.id === selectedOption.id
            : false
        }
        data-wb-fieldflow="{&quot;bind&quot;:&quot;legislation-7&quot;}"
        value={value}
        readOnly
        style={{
          width: '20px',
          height: '20px',
          minWidth: '20px',
          cursor: 'pointer',
          marginTop: '2px',
          flexShrink: 0,
        }}
      />
      <label
        htmlFor={`legislation-${index}`}
        style={{
          fontSize: '18px',
          lineHeight: '1.5',
          paddingLeft: '10px',
          cursor: 'pointer',
          display: 'inline-block',
          minHeight: '44px',
          verticalAlign: 'top',
          alignItems: 'center',
          paddingTop: '4px',
        }}
      >
        {label}
      </label>
    </li>
  );
}